<script setup>
import { isMobile } from '@/utils/isMobile'
import { useFilterStore } from '@/store/filter'
import SingleFilterWrapper from '../miscellaneous/filters/SingleFilterWrapper.vue'

const filtersStore = useFilterStore()
const { allFilters, count, countAppliedFilters } = storeToRefs(filtersStore)
const { resetFilters } = filtersStore

const filterUIWrapperComponent = computed(() => {
    if (isMobile.any()) {
        return 'v-bottom-sheet'
    }
    return 'v-dialog'
})

const Filters = computed(() => {
    return allFilters.value
})
</script>
<template>
    <div class="d-flex align-center">
        <v-btn
            v-if="countAppliedFilters > 0"
            variant="text"
            @click="resetFilters"
            prepend-icon="mdi-filter-remove-outline"
            class="text-capitalize ml-1 mr-2"
            >{{ $t('resetFilters') }}
        </v-btn>
        <component :is="filterUIWrapperComponent" max-width="560">
            <template v-slot:activator="{ props: activatorProps }">
                <v-badge
                    :content="countAppliedFilters"
                    color="red"
                    floating
                    offset-x="10"
                    offset-y="10"
                >
                    <v-btn v-bind="activatorProps" variant="outlined" class="filters-btn">
                        <v-icon class="d-inline mr-1"> mdi-filter-outline </v-icon>
                        <span class="d-none d-md-inline text-capitalize">{{ $t('filter') }}</span>
                    </v-btn>
                </v-badge>
            </template>

            <template v-slot:default="{ isActive }">
                <v-card class="pa-3 rounded">
                    <div class="d-flex justify-space-between">
                        <div class="filters-title ma-3">Filter Units</div>
                        <div @click="isActive.value = false" class="text-grey ma-3">
                            <v-icon class="cursor-pointer">mdi-close</v-icon>
                        </div>
                    </div>
                    <v-divider class="d-md-none"></v-divider>

                    <v-card-title>
                        <div class="d-flex justify-space-between mt-2">
                            <div>
                                <span class="filters-count d-block mx-2">
                                    <strong>{{ $t('showing') }}</strong>
                                    {{ `${count.filtered} /  ${count.total}` }}
                                </span>
                            </div>
                            <div v-if="countAppliedFilters > 0">
                                <v-badge :content="countAppliedFilters" color="red">
                                    <v-btn
                                        @click="resetFilters"
                                        variant="tonal"
                                        title="Reset all filters"
                                    >
                                        <v-icon>mdi-filter-remove-outline</v-icon>
                                    </v-btn>
                                </v-badge>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text :key="countAppliedFilters">
                        <div v-for="(singleFilter, index) of Filters" :key="index">
                            <SingleFilterWrapper
                                :filter="singleFilter"
                                :countAppliedFilters="countAppliedFilters"
                            />
                        </div>
                    </v-card-text>

                    <v-card-actions>
                        <v-btn @click="isActive.value = false" class="bg-light-blue-darken-3" block>
                            {{ $t('applyFilters') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </component>
    </div>
</template>
<style scoped>
.filters-title {
    font-size: 1.5em;
    display: block;
    font-weight: 600;
}

.filter-title {
    margin-bottom: 2px;
    text-transform: uppercase;
}

span.filters-count {
    font-size: 0.75em !important;
}

.filter-option {
    min-width: 150px;
}

.filters-btn {
    border-color: #e0e0e0;
}

.text-transform-normal {
    text-transform: none;
}
</style>
